var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3H17H15.5H14H12.5H11H9.5H8H6.5H6C5.44772 3 5 3.44772 5 4V16H2V19C2 20.66 3.34 22 5 22H17C18.66 22 20 20.66 20 19V4C20 3.44772 19.5523 3 19 3H18.5ZM14 20H5C4.45 20 4 19.55 4 19V18H14V20ZM18 19C18 19.55 17.55 20 17 20C16.45 20 16 19.55 16 19V16H7V5H18V19Z",
    fill: "#4555D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H8V9H14V7Z",
    fill: "#4555D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7H15V9H17V7Z",
    fill: "#4555D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H8V12H14V10Z",
    fill: "#4555D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H15V12H17V10Z",
    fill: "#4555D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.5035e15c43155d46740fbf7acadd9921.svg";
export { ForwardRef as ReactComponent };